<app-banner [heading]="'OUR MISSION & VISION'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>


<section id="about" class="mb-4">

  <div class="container">
    <div class="row">

      <div class="col-lg-6 col-md-6">
        <div class="about-img">
          <img src="/assets/img/vision/1.jpeg" alt="best school in kurukshetra">
        </div>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="about-content">
          <h6 class=""> Our Vision</h6>
          
          <p>Our Vision is to impart skills and values to our children by offering differentiated,
         effective and
    rigorous curriculum in a happy, caring and stimulating environment.<br><br>
    To develop <strong>Tagore Global School</strong> into a vibrant and an exemplary educational institution where
    Students are nurtured and encouraged to achieve their ultimate potential.<br><br>
    High quality standards of teaching and learning in a caring environment is the very heart of
    Our purpose in which significant emphasis is placed on individual student’s achievement and
    the celebration of success.

    </p>
          
        </div>
      </div>
  
  <div class="col-lg-6 col-md-6">
        <div class="about-content">
          <h6 class=""> Our Mission</h6>
          
          <p>We are committed to be an exceptional school with a difference.<br><br> The graduates of our
    school will be cognizant, sensitive, reflective and participative individual who, take 
    pride in themselves and the nation, will impact and influence a changing society with 
    confidence and creativity. <br><br>The school is committed to provide a challenging, enriching
    and purposeful learning environment on a sustained basis in the belief that this engages 
    students in maximum learning
    </p>
          
        </div>
      </div>
  <div class="col-lg-6 col-md-6">
        <div class="about-img">
          <img src="/assets/img/vision/2.jpeg" alt="best school in kurukshetra">
        </div>
      </div>
  
  
    </div>
  </div>

</section>